import { render } from "./spec-list.vue?vue&type=template&id=cd8942d8&lang=pug"
import script from "./spec-list.vue?vue&type=script&lang=js"
export * from "./spec-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__